//React
import React, { useEffect, useState, useContext } from "react";

import {
  Grid,
  FormControlLabel,
  Switch,
  Typography,
  Icon,
} from "@material-ui/core";

import {
  Block,
  Drafts,
  EditOutlined,
  Email,
  Print,
  Visibility,
  Info,
  Code,
  FileCopy,
  AssignmentReturned,
} from "@material-ui/icons";

import HeaderModule from "../../../components/header/HeaderModule";
import Card from "../../../components/cards/Card";
import Btn from "../../../components/buttons/Btn";
import Chip from "../../../components/basics/Chip";
import TextField from "../../../components/basics/TextFieldErp";
import SelectErp from "../../../components/basics/SelectErp";

import {
  PainelContainer,
  DataAria,
  BtnNewAria,
  ButtonsAria,
  TableContent,
  Line,
} from "./styles/Nfe";

import { useHistory } from "react-router";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { PainelNfeContext } from "./contexts/PainelNfeContext";
import useNfeController from "./controllers/NfeController";
import ModalCancelamentoNfe from "./children/ModalCancelamentoNfe";
import ModalDuplicataMercantil from "./children/ModalDuplicataMercantil";
import ModalEmailNfe from "./children/ModalEmailNfe";
import Loading from "../../../components/basics/Loading";
import ModalCartaCorrecao from "./children/ModalCartaCorrecao";
import BigDataTable from "../../../components/tables/BigDataTable";
import ModalInutilizarNfe from "./children/ModalInutilizarNfe";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import ModalLogNFe from "./children/ModalLogNFe";
import ModalVerVendas from "./children/ModalVerVendas";
import ModalAtualizaXml from "./children/ModalAtualizaXml";
import ModalAvisoDescontinuacaoEmissaoNfe from "./children/ModalAvisoDescontinuacaoEmissaoNfe";
import MaskService from "../../../utils/mask/maskService";
import { getSeries } from "../../../repositories/qerpapi/v3/serie/SerieRepository";
import { GlobalVariables } from "../../../GlobalVariables";
import { notify } from "../../../utils/notify";
import { getSummaryDocumentsConfig } from "../../../repositories/qerpapi/v3/documentosfiscais";
import Swal from "sweetalert2";

const NfeView = ({ ...props }) => {
  const {
    optionsStatus,
    setOptionsStatus,
    cfop,
    setCfop,
    receiver,
    setReceiver,
    numberNfe,
    setNumberNfe,
    selectedItem,
    setSelectedItem,
    iniDate,
    setIniDate,
    finallyDate,
    setFinallyDate,
    queryWhere,
    queryOrWhere,
    queryBetween,
    listSeries,
    setListSeries,
    filterSeries,
    setFilterSeries,
    typeNfe,
    setTypeNfe,
    accesKey,
    setAccesKey,
    downloadXml,
    setDownloadXml,
    downloadDanfePdf,
    setDownloadDanfePdf,
    downloadCCe,
    setDownloadCCe,
    downloadXmlReturn,
    setDownloadXmlReturn,
    mainLoading,
    setMainLoading,
    singleFolder,
    setSingleFolder,
    hasCanceled,
    setHasCanceled,
    hasSalesInNfe,
    setHasSalesInNfe,
    filterModel,
    setFilterModel,
    defaultListModels,
    listModels,
    setListModels,
    modelsListLoading,
    setModelsListLoading,
  } = useContext(PainelNfeContext);

  const {
    handleGetDataTable,
    handleDownloadMultiplesDanfes,
    handleDownloadArchives,
    handleVerifyNfeStatus,
    handleCloneNfe,
  } = useNfeController();

  const [disableBtn, setDisableBtn] = useState(true);
  const [nfeId, setNfeId] = useState("");
  const [nfeRow, setNfeRow] = useState({});
  // eslint-disable-next-line
  const [nfeIds, setNfeIds] = useState([]);
  const [nfeData, setNfeData] = useState([]);

  /* Actions Modals Open */
  const [openCancelNfe, setOpenCancelNfe] = useState(false);
  const [openCC, setOpenCC] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [openInutilizar, setOpenInutilizar] = useState(false);
  const [openVerVendas, setOpenVerVendas] = useState(false);
  const [openDuplicataMercantil, setOpenDuplicataMercantil] = useState(false);
  const [disabledUnusable, setDisabledUnusable] = useState(false);
  const [openLogNfe, setOpenLogNfe] = useState(false);
  const [openUpdateXml, setOpenUpdateXml] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [openAvisoDescontinuacao, setOpenAvisoDescontinuacao] =
    useState(true);

  const { queryParams } = useContext(QueryParamsContext);

  const { push } = useHistory();

  const handleVerifyIntegrationId = (value) => {
    const hasIntegrationId = !!(value?.integracao_id || "").trim();

    if (hasIntegrationId) {
      Swal.fire({
        icon: "warning",
        html: `
          <strong style="font-size: 1.1rem;">Esta NF-e foi emitida pelo novo Emissor</strong>
          <p style="margin-top: 0.5rem; color: #555;">
            Realize esta operação pelo menu <strong>Emissor DF-e (Nova Nota Fiscal)</strong>.
          </p>
        `,
        showConfirmButton: true,
        confirmButtonText: "OK",
      });
    }

    return hasIntegrationId;
  };

  useEffect(() => {
    setHasCanceled(selectedItem.some((current) => current.status === "C"));
    if (selectedItem.length > 0) {
      setDisableBtn(false);

      const auxIds = [];
      selectedItem.forEach((element) => {
        auxIds.push(element.id);
      });
      setNfeIds(auxIds);
    } else {
      setDisableBtn(true);
    }
  }, [selectedItem, setHasCanceled]);

  useEffect(() => {
    let invalidTaxNotes = [];
    if (selectedItem.length) {
      invalidTaxNotes = selectedItem.filter((item) => {
        if (item.status !== "D") return true;

        if (
          item?.estabelecimento_rural_id &&
          queryParams.cnpj_cpf.length === 11
        )
          return true;

        return false;
      });
    }
    setDisabledUnusable(invalidTaxNotes.length);
  }, [queryParams.cnpj_cpf, selectedItem]);

  useEffect(() => {
    if (!openCancelNfe && queryParams.id && !!filterModel) {
      handleGetDataTable();
    }
    // eslint-disable-next-line
  }, [openCancelNfe, queryParams.empresa_cnpj, queryParams.id]);

  useEffect(() => {
    if (!queryParams.empresa_id) return;

    (async () => {
      try {
        const callbackSeries = await getSeries({
          companyId: queryParams.empresa_id,
        });

        if (!callbackSeries?.success)
          return notify(
            "Não foi possível obter a lista de séries!",
            true,
            "error"
          );

        callbackSeries.data.forEach((element, index) => {
          element.serieNumber = element.serieNumber.toString();
        });

        setListSeries(callbackSeries.data || []);
      } catch (error) {
        console.error(error);
        notify("Não foi possível obter a lista de séries!", true, "error");
      }
    })();
  }, [queryParams.empresa_id, setListSeries, setFilterSeries]);

  useEffect(() => {
    if (!filterModel) return;
    handleGetDataTable();
    // eslint-disable-next-line
  }, [typeNfe]);

  useEffect(() => {
    if (!openUpdateXml && !!filterModel) {
      handleGetDataTable();
    }
    // eslint-disable-next-line
  }, [openUpdateXml]);

  useEffect(() => {
    if (!queryParams?.empresa_id) return;

    (async () => {
      try {
        setModelsListLoading(true);

        const summaryDocumentsResponse = await getSummaryDocumentsConfig({
          companyId: queryParams.empresa_id,
        });

        if (!summaryDocumentsResponse?.success)
          return notify(
            summaryDocumentsResponse?.message ||
              "Não foi possível obter a lista dos modelos de documentos fiscais!",
            true,
            "error"
          );

        const { data } = summaryDocumentsResponse;

        let copyListModels = [...defaultListModels];

        const fiscalDocuments = {
          nfe: {
            model: "55",
            active: data.nfe,
          },
          nfce: {
            model: "65",
            active: data.nfce,
          },
        };

        Object.values(fiscalDocuments).forEach((document) => {
          if (!document.active) {
            copyListModels = copyListModels.filter(
              (model) => model.value !== document.model
            );
          }
        });

        if (copyListModels.length === 1) {
          setFilterModel(copyListModels[0]);
        }

        setListModels(copyListModels);
      } catch (error) {
        console.error(error);
        notify(
          "Não foi possível obter a lista dos modelos de documentos fiscais!",
          true,
          "error"
        );
      } finally {
        setModelsListLoading(false);
      }
    })();
  }, [
    defaultListModels,
    queryParams?.empresa_id,
    setListModels,
    setModelsListLoading,
    setFilterModel,
  ]);

  const jsonOptionsList = {
    R: <Chip bgcolor="green" label="Transmitida" textcolor="white"></Chip>,
    D: <Chip bgcolor="blue" label="Em digitação" textcolor="white"></Chip>,
    C: <Chip bgcolor="red" label="Cancelada" textcolor="white"></Chip>,
    T: <Chip bgcolor="tertiary" label="Complementar" textcolor="white"></Chip>,
    I: <Chip bgcolor="orange" label="Inutilizada" textcolor="white"></Chip>,
    G: <Chip bgcolor="orange" label="Denegada" textcolor="white"></Chip>,
  };

  const columnsTable = [
    {
      label: "Ações",
      format: (value) => {
        let itemActions = [
          {
            icon: <EditOutlined />,
            name: "Abrir NFe",
            action: () =>
              push(`/financeiro/nfe/emissao`, {
                id: value.id,
                operation: "edit",
              }),
          },
          {
            icon: <Block />,
            name: "Cancelar NFe",
            action: () => {
              if (handleVerifyIntegrationId(value)) return;

              setHasSalesInNfe(
                !!(
                  value.contasreceber.length &&
                  value.contasreceber?.filter(
                    (current) => current.origem === "NFe"
                  )
                )
              );
              setNfeId(value.id);
              setOpenCancelNfe(true);
            },
            disabled: value.status !== "R" || value.status === "G",
          },
          {
            icon: <Code />,
            name: "Atualiza XML",
            action: () => {
              if (handleVerifyIntegrationId(value)) return;

              setNfeData(value);
              setOpenUpdateXml(true);
            },
            disabled: value.status === "G",
          },
          {
            icon: <Drafts />,
            name: "Carta de Correção",
            action: () => {
              if (handleVerifyIntegrationId(value)) return;

              setNfeId(value.id);
              setOpenCC(true);
            },
            disabled:
              value.status === "C" ||
              value.status === "D" ||
              value.status === "G",
          },
          {
            icon: <Email />,
            name: "Enviar Email",
            action: () => {
              if (handleVerifyIntegrationId(value)) return;

              setNfeData(value);
              setOpenEmail(true);
            },
            disabled: value.status === "D" || value.status === "G",
          },
          {
            icon: <Visibility />,
            name: "Ver vendas",
            action: () => {
              setNfeId(value.id);
              setOpenVerVendas(true);
            },
            disabled: !value.vendas.length || value.status === "G",
          },
          {
            icon: <Info />,
            name: "Exibir log da NFe",
            action: () => {
              setNfeId(value.id);
              setNumberNfe(value.numero);
              setOpenLogNfe(true);
            },
          },
          {
            icon: <FileCopy />,
            name: "Clonar NFe",
            action: () => {
              if (handleVerifyIntegrationId(value)) return;

              handleCloneNfe({ id: value.id, regime: value.regime });
            },
          },
          {
            icon: <AssignmentReturned />,
            name: "Duplicata Mercantil / Boleto",
            action: () => {
              setNfeRow(value);
              setOpenDuplicataMercantil(true);
            },
            disabled:
              value.status !== "R" ||
              !value.hasValidFinancial ||
              queryParams?.paramutilizaetiquetaeduplicataliatanf ===
                GlobalVariables.company.params.utilizaetiquetaeduplicataliatanf
                  .no,
          },
        ];

        return <SpeedDialErp actions={itemActions} />;
      },
      align: "center",
    },
    {
      label: "Status",
      id: "status",
      align: "center",
      format: (value) => jsonOptionsList[value.status],
    },
    {
      label: "Modelo",
      id: "modelo",
      align: "center",
      style: { minWidth: 70 },
    },
    {
      label: "Série",
      id: "serie",
      align: "center",
      style: { minWidth: 70 },
    },
    {
      label: "CFOP",
      id: "cfop",
      align: "center",
      style: { minWidth: 70 },
    },
    {
      label: "Nro",
      id: "numero",
      align: "center",
      style: { minWidth: 70 },
    },
    {
      label: "Data Emissão",
      align: "center",
      style: { minWidth: 145 },
      format: (value) => {
        return MaskService.dateYmdToDmy(value.dataemissao);
      },
      id: "dataemissao",
    },
    {
      label: "Valor Nfe",
      align: "center",
      format: (value) =>
        Number(value.vl_nf).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        }),
      style: { minWidth: 120 },
      id: "vl_nf",
    },
    {
      label: "Remetente/Destinatário",
      id: "nome",
      align: "center",
      style: { minWidth: 250 },
    },
  ];

  const listOptionsStatus = [
    {
      label: "Transmitida",
      value: "R",
    },
    {
      label: "Em digitação",
      value: "D",
    },
    {
      label: "Cancelada",
      value: "C",
    },
    {
      label: "Complementar",
      value: "T",
    },
    {
      label: "Inutilizada",
      value: "I",
    },
    {
      label: "Denegada",
      value: "G",
    },
  ];
  return (
    <>
      <ModalAvisoDescontinuacaoEmissaoNfe
        open={openAvisoDescontinuacao}
        setOpen={setOpenAvisoDescontinuacao}
      />
      {openEmail && (
        <ModalEmailNfe
          modalOpen={openEmail}
          setModalOpen={setOpenEmail}
          nfe={nfeData}
          setMainLoading={setMainLoading}
        />
      )}
      {openCC && (
        <ModalCartaCorrecao
          nfeId={nfeId}
          modalCartaCorrecaoOpen={openCC}
          setModalCartaCorrecaoOpen={setOpenCC}
          setMainLoading={setMainLoading}
        />
      )}
      {openCancelNfe && (
        <ModalCancelamentoNfe
          nfeId={nfeId}
          hasSalesInNfe={hasSalesInNfe}
          modalCancelamentoOpen={openCancelNfe}
          setModalCancelamentoOpen={setOpenCancelNfe}
          setLoading={setMainLoading}
        />
      )}
      {openInutilizar && (
        <ModalInutilizarNfe
          openModal={openInutilizar}
          setOpenModal={setOpenInutilizar}
          selectedNotes={selectedItem}
          setMainLoading={setMainLoading}
        />
      )}
      {openUpdateXml && (
        <ModalAtualizaXml
          openModal={openUpdateXml}
          setOpenModal={setOpenUpdateXml}
          nfe={nfeData}
          setMainLoading={setMainLoading}
        />
      )}
      {openLogNfe && (
        <ModalLogNFe
          openModal={openLogNfe}
          setOpenModal={setOpenLogNfe}
          nfeId={nfeId}
          numberNfe={numberNfe}
          setMainLoading={setMainLoading}
        />
      )}
      {openVerVendas && (
        <ModalVerVendas
          modalOpen={openVerVendas}
          setModalOpen={setOpenVerVendas}
          nfe={nfeId}
          setMainLoading={setMainLoading}
        />
      )}
      {openDuplicataMercantil && (
        <ModalDuplicataMercantil
          openModal={openDuplicataMercantil}
          setOpenModal={setOpenDuplicataMercantil}
          nfeRow={nfeRow}
          setNfeRow={setNfeRow}
        />
      )}

      <Loading open={mainLoading || modelsListLoading} />
      <HeaderModule
        title="NOTA FISCAL ELETRÔNICA (NFe) - Painel"
        videoId={GlobalVariables.screenVideosIds.controleNfe}
      />
      <PainelContainer maxWidth="xl">
        <Card>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <TextField
                label="Data Inicial"
                variant="filled"
                type="date"
                size="small"
                value={iniDate}
                setValue={setIniDate}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Data Final"
                variant="filled"
                type="date"
                size="small"
                value={finallyDate}
                setValue={setFinallyDate}
              />
            </Grid>

            <Grid item xs={4}>
              <SelectErp
                id="nfe-status"
                optionsList={listOptionsStatus}
                descriptionField="label"
                value={optionsStatus}
                setValue={setOptionsStatus}
                label="Status"
              />
            </Grid>
            <Grid item xs={2}>
              <TextField value={cfop} label="CFOP" setValue={setCfop} />
            </Grid>
            <Grid item xs={5}>
              <TextField
                id="nfe-remetente"
                value={receiver}
                label="Remetente / Destinatário"
                setValue={setReceiver}
              />
            </Grid>
            <Grid item xs={7}>
              <TextField
                id="nfe-chave"
                value={accesKey}
                label="Chave de Acesso"
                setValue={setAccesKey}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectErp
                optionsList={listModels}
                descriptionField="label"
                value={filterModel}
                onChange={(value) => {
                  if (!value) return;
                  setFilterModel(value);
                }}
                label="Modelo"
              />
            </Grid>
            <Grid item xs={4}>
              <SelectErp
                getOptionLabel={(option) =>
                  `${option.serieNumber || "-"} - ${option.description || "-"}`
                }
                optionsList={listSeries.filter(
                  (serie) => serie.model === filterModel?.value
                )}
                value={filterSeries}
                setValue={setFilterSeries}
                label="Série"
              />
            </Grid>
            <Grid item>
              <TextField
                value={numberNfe}
                label="Numero"
                setValue={setNumberNfe}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                label={typeNfe ? "Saida" : "Entrada"}
                value="end"
                labelPlacement="start"
                control={
                  <Switch
                    checked={typeNfe}
                    onChange={() => {
                      setTypeNfe((current) => !current);
                    }}
                    color="primary"
                  />
                }
              />
            </Grid>
            <Grid item container xs justifyContent="flex-end">
              <Btn
                label="Buscar"
                bgcolor="tertiary"
                hovercolor="blue"
                startIcon={<Icon>search</Icon>}
                onClick={handleGetDataTable}
              />
            </Grid>
          </Grid>
        </Card>
        <DataAria>
          <Card>
            <TableContent>
              <Grid container spacing={3}>
                <Grid item xs={9}>
                  <BigDataTable
                    tableTitle=""
                    route="nf/notasfiscais/v1"
                    columns={columnsTable}
                    where={queryWhere}
                    orWhere={queryOrWhere}
                    between={queryBetween}
                    fixedSort="-numero"
                    initialSort="-numero"
                    selectable={true}
                    selected={selectedItem}
                    setSelected={setSelectedItem}
                    include={
                      "vendas,notasfiscaisarchives,nfelotenf,contasreceber"
                    }
                    initialFunction={(callback) =>
                      handleVerifyNfeStatus(callback)
                    }
                    allSelected={allSelected}
                    setAllSelected={setAllSelected}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Grid item xs={12}>
                    <BtnNewAria>
                      <Btn
                        label="Nova Nota Fiscal"
                        bgcolor="primary"
                        hovercolor="orange"
                        onClick={() => {
                          push(
                            `/financeiro/nfe/emissao?gfAccessToken=${
                              queryParams.gfAccessToken || ""
                            }`
                          );
                        }}
                        startIcon={<Icon>add</Icon>}
                        full="true"
                      />
                    </BtnNewAria>
                  </Grid>
                  <Grid item xs={12}>
                    <ButtonsAria>
                      {/* <Btn
                            label="Transmitir"
                            bgcolor="tertiary"
                            hovercolor="blue"
                            startIcon={<Icon>synchronize</Icon>}
                            full="true"
                            disabled={disableBtn}
                          /> */}
                      <Btn
                        type="submit"
                        label="Etiqueta"
                        bgcolor="blue"
                        hovercolor="darkblue"
                        startIcon={<Icon>download</Icon>}
                        disabled={
                          selectedItem.filter(
                            (element) => element.status !== "R"
                          ).length || !selectedItem.length
                        }
                        onClick={() => {
                          handleDownloadMultiplesDanfes(
                            selectedItem,
                            setMainLoading,
                            true,
                            1
                          );
                        }}
                        full="true"
                      />
                      <Btn
                        label="Imprimir"
                        bgcolor="green"
                        hovercolor="darkgreen"
                        startIcon={<Print />}
                        full="true"
                        onClick={() => {
                          handleDownloadMultiplesDanfes(selectedItem);
                        }}
                        disabled={!selectedItem.length}
                      />
                      <Btn
                        label="Inutilizar"
                        bgcolor="red"
                        hovercolor="darkred"
                        startIcon={<Icon>delete</Icon>}
                        disabled={disabledUnusable}
                        full="true"
                        onClick={() => {
                          setOpenInutilizar(true);
                        }}
                      />
                    </ButtonsAria>
                    <Card>
                      <FormControlLabel
                        value="end"
                        control={
                          <Switch
                            checked={singleFolder}
                            onChange={() =>
                              setSingleFolder((current) => !current)
                            }
                            color="primary"
                          />
                        }
                        label="Download em Pasta Única"
                        labelPlacement="start"
                      />
                      <Line />
                      <Typography variant="subtitle2" gutterBottom>
                        Selecione o(s) arquivo(s) que deseja fazer download
                      </Typography>
                      <Grid container>
                        <Grid item>
                          <FormControlLabel
                            value="end"
                            control={
                              <Switch
                                checked={downloadXml}
                                onChange={() =>
                                  setDownloadXml((current) => !current)
                                }
                                color="primary"
                              />
                            }
                            label="XML"
                            labelPlacement="start"
                          />
                        </Grid>
                        <Grid item>
                          <FormControlLabel
                            value="end"
                            control={
                              <Switch
                                checked={downloadDanfePdf}
                                onChange={() =>
                                  setDownloadDanfePdf((current) => !current)
                                }
                                color="primary"
                              />
                            }
                            label="Danfe"
                            labelPlacement="start"
                          />
                        </Grid>
                        <Grid item>
                          <FormControlLabel
                            value="end"
                            control={
                              <Switch
                                checked={downloadCCe}
                                onChange={() =>
                                  setDownloadCCe((current) => !current)
                                }
                                color="primary"
                              />
                            }
                            label="CCe"
                            labelPlacement="start"
                          />
                        </Grid>
                        {hasCanceled && (
                          <Grid item>
                            <FormControlLabel
                              value="end"
                              control={
                                <Switch
                                  checked={downloadXmlReturn}
                                  onChange={() =>
                                    setDownloadXmlReturn((current) => !current)
                                  }
                                  color="primary"
                                />
                              }
                              label="XML Retorno"
                              labelPlacement="start"
                            />
                          </Grid>
                        )}
                      </Grid>
                      <Btn
                        label="Download"
                        bgcolor="blue"
                        hovercolor="darkblue"
                        startIcon={<Icon>download</Icon>}
                        disabled={disableBtn}
                        full="true"
                        onClick={() => {
                          handleDownloadArchives(selectedItem, {
                            allSelected,
                            queryWhere,
                            queryOrWhere,
                            queryBetween,
                          });
                        }}
                      />
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </TableContent>
          </Card>
        </DataAria>
      </PainelContainer>
    </>
  );
};

export default NfeView;
